import { __exportAll } from "../_virtual/_rolldown/runtime.js";
import { UniversalTime } from "@biteinc/helpers-universal";
//#region src/helpers/i9n_availability_helper.ts
var i9n_availability_helper_exports = /* @__PURE__ */ __exportAll({ doesTimePassI9nAvailability: () => doesTimePassI9nAvailability });
function doesTimePassI9nAvailability(availability, time, tz) {
	if (availability.dates && availability.dates.length > 0) {
		if (!availability.dates.find((datePair) => {
			const from = datePair.from;
			const to = datePair.to;
			if (from !== null && to === null) return from <= time;
			if (from === null && to !== null) return time <= to;
			if (from !== null && to !== null) return from <= time && time <= to;
			return false;
		})) return false;
	}
	if (availability.days && availability.days.length > 0) {
		const dayTimestamp = UniversalTime.dayTimestampFromTime(time, tz);
		const day = UniversalTime.getWeekdayFromUnixTime(time, tz);
		if (!availability.days.find((dayInfo) => {
			if (dayInfo.day !== day) return false;
			return dayInfo.from <= dayTimestamp && dayTimestamp <= dayInfo.to;
		})) return false;
	}
	return true;
}
//#endregion
export { doesTimePassI9nAvailability, i9n_availability_helper_exports };

//# sourceMappingURL=i9n_availability_helper.js.map